import { IHttpApi } from '@cian/http-api/';

import { ResponseError } from '../../errors';
import {
  fetchGetBannerEnrichments,
  TGetBannerEnrichmentsRequest,
} from '../../repositories/ad-banner/v1/get-banner-enrichments';

interface IParams {
  httpApi: IHttpApi;
  parameters: TGetBannerEnrichmentsRequest;
}
export async function getNewbuildingInfoForTgb({ httpApi, parameters }: IParams) {
  const result = await fetchGetBannerEnrichments<never, never>({
    httpApi,
    parameters,
  });

  if (result.statusCode !== 200) {
    throw new ResponseError({
      domain: 'getNewbuildingInfoForTgb',
      message: result.response.message || 'Неизвестная ошибка загрузки информации по баннеру',
    });
  }

  return result.response;
}
